var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-inline-flex mb-4" }, [
        _vm.effect_fields.length
          ? _c("div", { staticClass: "form-check mr-3" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectAll,
                    expression: "selectAll"
                  }
                ],
                staticClass: "form-check-input select-all mt-0",
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.selectAll)
                    ? _vm._i(_vm.selectAll, null) > -1
                    : _vm.selectAll
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.selectAll,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectAll = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectAll = $$c
                    }
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h4", { staticClass: "mr-3 mb-0" }, [
          _vm._v("\n      Effects\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("span", { staticClass: "cursor-pointer" }, [
            _c("img", {
              staticClass: "heading-icon",
              attrs: { src: require("@/assets/addplus_icon.svg"), width: "20" },
              on: { click: _vm.showAddNewEffectModal }
            })
          ]),
          _vm._v(" "),
          _vm.effect_fields.length
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer ml-3",
                  on: {
                    click: function($event) {
                      return _vm.deleteAllEffects()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.effect_fields, function(effectitem, index) {
        return _c("div", { key: index, staticClass: "mb-3" }, [
          _c(
            "div",
            { staticClass: "fields-wrapper is-divider is-multi-node" },
            [
              _c("div", { staticClass: "form-check select-single" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: effectitem.effect.selectSingle,
                      expression: "effectitem.effect.selectSingle"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(effectitem.effect.selectSingle)
                      ? _vm._i(effectitem.effect.selectSingle, null) > -1
                      : effectitem.effect.selectSingle
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = effectitem.effect.selectSingle,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                effectitem.effect,
                                "selectSingle",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                effectitem.effect,
                                "selectSingle",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(effectitem.effect, "selectSingle", $$c)
                        }
                      },
                      _vm.checkSingleSelect
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              !effectitem.effect.isCopied || effectitem.effect.selectSingle
                ? _c("div", { staticClass: "action-buttons" }, [
                    !effectitem.effect.isCopied
                      ? _c(
                          "span",
                          {
                            staticClass: "action-item ",
                            on: {
                              click: function($event) {
                                return _vm.copyEffect(index, effectitem)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-copy" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    effectitem.effect.selectSingle
                      ? _c(
                          "span",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function($event) {
                                return _vm.deleteEffect(index, effectitem)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash" })]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-3 col-form-label",
                          attrs: { for: "effect_selector" }
                        },
                        [
                          _vm._v(
                            "\n              Effect Selector\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: effectitem.effect.name,
                                expression: "effectitem.effect.name"
                              }
                            ],
                            staticClass: "custom-select",
                            attrs: { id: "effect_selector" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    effectitem.effect,
                                    "name",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.changeSelectedEffectItem(
                                    index,
                                    effectitem.effect.name
                                  )
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.effects, function(effectSelector, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                staticClass: "custom-select",
                                domProps: { value: effectSelector.name }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(effectSelector.name) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n              Effect Type\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: effectitem.effect.effectType,
                                expression: "effectitem.effect.effectType"
                              }
                            ],
                            staticClass: "custom-select",
                            attrs: { placeholder: "Select Effect Type" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  effectitem.effect,
                                  "effectType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "2D" } }, [
                              _vm._v("2D")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "3D" } }, [
                              _vm._v("3D")
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-3 col-form-label",
                          attrs: { for: "start_time" }
                        },
                        [_vm._v("\n              Start Time\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: effectitem.effect.startTime,
                              expression: "effectitem.effect.startTime"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "start_time" },
                          domProps: { value: effectitem.effect.startTime },
                          on: {
                            change: function($event) {
                              return _vm.setDuration(index)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                effectitem.effect,
                                "startTime",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-3 col-form-label",
                          attrs: { for: "end_time" }
                        },
                        [_vm._v("\n              End Time\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: effectitem.effect.endTime,
                              expression: "effectitem.effect.endTime"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "end_time" },
                          domProps: { value: effectitem.effect.endTime },
                          on: {
                            change: function($event) {
                              return _vm.setDuration(index)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                effectitem.effect,
                                "endTime",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v("\n            Loop\n          ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "input-switch label-right p-0" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: effectitem.effect.loop,
                                      expression: "effectitem.effect.loop"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: effectitem.effect.id
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      effectitem.effect.loop
                                    )
                                      ? _vm._i(effectitem.effect.loop, null) >
                                        -1
                                      : effectitem.effect.loop
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = effectitem.effect.loop,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              effectitem.effect,
                                              "loop",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              effectitem.effect,
                                              "loop",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(effectitem.effect, "loop", $$c)
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label-left",
                                    attrs: { for: effectitem.effect.id }
                                  },
                                  [_c("span")]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v(
                          "\n              Position of origin (meters)\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.position[0],
                                  expression: "effectitem.effect.position[0]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "position_of_origin_x"
                              },
                              domProps: {
                                value: effectitem.effect.position[0]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.position,
                                    0,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.position[1],
                                  expression: "effectitem.effect.position[1]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "position_of_origin_y"
                              },
                              domProps: {
                                value: effectitem.effect.position[1]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.position,
                                    1,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.position[2],
                                  expression: "effectitem.effect.position[2]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "position_of_origin_z"
                              },
                              domProps: {
                                value: effectitem.effect.position[2]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.position,
                                    2,
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v(
                          "\n              Rotation of origin (meters)\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.rotation[0],
                                  expression: "effectitem.effect.rotation[0]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "rotation_of_origin_x"
                              },
                              domProps: {
                                value: effectitem.effect.rotation[0]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.rotation,
                                    0,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.rotation[1],
                                  expression: "effectitem.effect.rotation[1]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "rotation_of_origin_y"
                              },
                              domProps: {
                                value: effectitem.effect.rotation[1]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.rotation,
                                    1,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.rotation[2],
                                  expression: "effectitem.effect.rotation[2]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "rotation_of_origin_z"
                              },
                              domProps: {
                                value: effectitem.effect.rotation[2]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.rotation,
                                    2,
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                        _vm._v(
                          "\n              Scale of origin (meters)\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.scale[0],
                                  expression: "effectitem.effect.scale[0]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "scale_of_origin_x" },
                              domProps: { value: effectitem.effect.scale[0] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.scale,
                                    0,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.scale[1],
                                  expression: "effectitem.effect.scale[1]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "scale_of_origin_y" },
                              domProps: { value: effectitem.effect.scale[1] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.scale,
                                    1,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: effectitem.effect.scale[2],
                                  expression: "effectitem.effect.scale[2]"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "scale_of_origin_z" },
                              domProps: { value: effectitem.effect.scale[2] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    effectitem.effect.scale,
                                    2,
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      }),
      _vm._v(" "),
      _vm.showModal
        ? [
            _c(
              "div",
              {
                staticClass: "modal",
                attrs: {
                  id: "character-modal",
                  tabindex: "-1",
                  role: "dialog",
                  "data-backdrop": "static",
                  "data-keyboard": "false"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-lg",
                    attrs: { role: "document" }
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "aria-label": "Close"
                          },
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "form-group col-12" }, [
                            _c("p", { staticClass: "font-weight-bold" }, [
                              _vm._v("Select Effect")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "models-wrapper" },
                              _vm._l(_vm.effects, function(effect, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "model-item",
                                    class: {
                                      active: _vm.activeChar === effect.name
                                    }
                                  },
                                  [
                                    effect.hasOwnProperty("image")
                                      ? _c("img", {
                                          staticClass: "img-fluid",
                                          attrs: { src: effect.image.imageURL }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("p", [_vm._v(_vm._s(effect.name))]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-1" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            id: "select_audio_duration_e"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.updatedSelectedEffect(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Select\n                      "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "text-center font-size-20" }, [
        _vm._v("\n              Effect Modal\n            ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20607d6a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20607d6a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/character/effects.vue
// module id = null
// module chunks = 